import SalonBusinessCpaTopicWorkspace from "./SalonBusinessCpaTopicWorkspace";

export default function SalonBusinessCpaGstHst() {
  return <SalonBusinessCpaTopicWorkspace topicKey="gst_hst" />;
}
